<template>
  <el-card class="absolute model-tree">
    <div class="w-full h-full">
      <el-tree
        class="modelTree"
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        show-checkbox
        :current-node-key="currentSelectItem"
        :filter-node-method="filterNode"
        :default-checked-keys="modelTreeProp.defaultCheckedKey"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="clickModelTree"
        @check="checkModelTree"
        node-key="node"
      ></el-tree>
    </div>
    <div class="w-100 mt-10px flex model-filter">
      <el-input
        size="small"
        placeholder="请输入要过滤的设备"
        prefix-icon="el-icon-search"
        v-model="filterTreeKeyWords"
        @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
        clearable
      >
      </el-input>
      <el-button
        type="primary"
        size="mini"
        @click="filterModelTree(modelTreeProp.currentNodeItem, true, filterTreeKeyWords, 0)"
      >
        <i class="el-icon-caret-top icon-yxr-sl fz-12"></i>
      </el-button>
      <el-button
        type="primary"
        size="mini"
        @click="filterModelTree(modelTreeProp.currentNodeItem, false, filterTreeKeyWords, 0)"
      >
        <i class="el-icon-caret-bottom icon-yxr-xl fz-12"></i>
      </el-button>
    </div>
  </el-card>
</template>

<script>
import _ from 'lodash'
import setModelVisible from '@/assets/js/modelTree'

export default {
  name: 'ModelTree',
  props: {
    player: {
      type: Object,
      default: null,
    },
    cloudRender: {
      type: Object,
      default: null,
    },
  },
  computed: {
    modelTreePropList() {
      return this.$store.getters['System/modelTreeProp'] || []
    },
    modelTreeProp() {
      return (
        _.find(this.modelTreePropList, ['engineId', this.player.config.engineId]) ||
        this.modelTreePropDefalut
      )
    },
  },
  watch: {
    'modelTreeProp.currentNodeName': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.currentNodeName = val
          this.filterModelTree(0, true, val, 3)
        }
      },
    },
    'modelTreeProp.defaultCheckedKey': {
      deep: true,
      handler(val, oldVal) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      },
    },
  },
  mounted() {
    if (this.modelTreeProp.currentNodeName) {
      // 页面初始化时不定位模型
      this.filterModelTree(0, true, this.modelTreeProp.currentNodeName, 0, false)
    }
  },
  data() {
    return {
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      defaultExpandedKeys: [], // 展开节点
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
      currentSelectItem: 0, // 当前选中的树节点item
      // 模型树相关
      modelTreePropDefalut: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
        modelTreeLoadEnd: false, // 模型树数据加载完毕
      },
    }
  },
  methods: {
    closeComponents() {
      this.$emit('closeComponent', 'ModelTree')
    },
    // 模型树点击操作
    clickModelTree(data, node, doLocation) {
      if (data.isVirtual) {
        return
      }
      if (node && node.checked && doLocation) {
        this.$emit('doLocation', data, 'modelTree')
        this.multipleLocations(this.player, data)
        this.modelTreeProp.currentNodeItem = data && data.node ? data.node : 0 // 储存选中节点的item
      }
      this.locationNode(data.node)
    },
    async multipleLocations(player, data, isSelect = true, isLoadEngine) {
      // 高亮选中的模型
      if (isSelect) {
        const selectNodes = await this.player.Native.Node.getSeletedNodes()
        await this.player.Native.Node.unSelectNodes(selectNodes)
        this.player.Native.Node.selectNodes([data.node])
      }
      this.player.Native.Camera.moveToNode(data.node, 2, 5)
    },
    // 模型树加载
    async loadNode(node, resolve) {
      if (node.level === 0) {
        const rootNode = await this.player.Native.Node.getRoot()
        const children = await this.player.Native.Node.getProperty(rootNode, ['children'])
        this.modelTreeProp.defaultCheckedKey = _.map(children.children, (val) => {
          return val.node
        })
        resolve(children.children)
        return
      }
      let res = null
      if (node.data.isVirtual) {
        res = node.data.childs
      } else {
        const result = await this.player.Native.Node.getProperty(node.data.node, ['children'])
        res = result?.children || []
      }
      const step = 1000 // 分片大小
      if (res.length > step) {
        const shardingRes = []
        for (let i = 0; i < _.ceil(res.length / step); i += 1) {
          shardingRes.push({
            name: `${i * step + 1}~${(i + 1) * step}`,
            checked: true,
            code: `${node.data.code}${i}`,
            node: `${node.data.node}${i}`,
            parentNode: node.data.node,
            visible: true,
            childs: res.slice(i * step, (i + 1) * step),
            isVirtual: true,
          })
        }
        res = shardingRes
      }
      const filterRes = _.filter(res, (el) => {
        return !el?.name.includes('_Clone')
      })
      const tempCheckedKey = _.map(filterRes, (val) => {
        return val.node
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.checked
        }),
        (res5) => {
          return res5.node
        }
      )
      // 保存this指向
      const that = this
      const isNoFindModelHides = (nodeObj) => {
        return (
          _.indexOf(
            _.map(that.modelTreeProp.modelHideList, (res1) => {
              return res1.node
            }),
            nodeObj.data.node
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在影藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在影藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在影藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在影藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else if (_.some(filterRes, { checked: false })) {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          this.modelTreeProp.defaultCheckedKey = [
            ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
              return val !== node.data.node
            }),
            ...checkedKeys,
          ]
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
        console.log('在这儿通过三维返回的设置显影')
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.node) {
          if (el.node === this.currentNode.node) {
            this.locationNode(this.currentNode.node)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)
        setTimeout(() => {
          const node = document.getElementsByClassName('modelTree')[0]
          const currentNode = document.getElementsByClassName('is-current')[0]
          // 将选中节点滚动到视口中间
          if (currentNode) {
            const treeRect = node.getBoundingClientRect()
            const nodeRect = currentNode.getBoundingClientRect()
            const offset = nodeRect.top - treeRect.top // 选中节点相对于树的顶部的偏移
            const midPoint = treeRect.height / 2 - nodeRect.height / 2 // 计算中间位置

            node.scrollTop += offset - midPoint // 设置滚动位置
          }
        }, 1000)
      })
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      const isChecked = _.includes(checkeds.checkedKeys, data.node)
      if (data.isVirtual) {
        this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
        return
      }
      setModelVisible(
        this.player,
        'checkModelTree',
        isChecked,
        [data.node],
        this.modelTreeProp,
        checkeds
      )
    },
    async filterModelTree(startItem, direction, KeyWords, type, doLocation = true) {
      // 过滤模型树
      const res = await this.player.Native.Node.findNode(startItem, {
        names: [KeyWords],
        codes: [KeyWords],
      })
      this.currentNode = res.codes
        ? res.codes[KeyWords] || {}
        : res.names
          ? res.names[KeyWords] || {}
          : {}
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode, doLocation)
      } else {
        // 未找到
        this.$message.error('搜索结果到底了')
      }
    },
    // 展开节点树
    async expendNode(node, doLocation) {
      const rootNode = await this.player.Native.Node.getRoot()
      const rootChild = await this.player.Native.Node.getProperty(rootNode, ['children'])
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      if (node.node === rootChild.children[0].node) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          if (!this.currentNodeName) {
            // 无激活节点时
            this.clickModelTree(this.currentNode, { checked: true }, doLocation)
          }
          // 有选中激活节点时
          this.currentNodeName = ''
          this.locationNode(this.currentNode.node)
        })
      } else {
        const res = await this.player.Native.Node.getProperty(node.node, ['parent'])
        const currentLevelNodes = await this.player.Native.Node.getProperty(res.parent, [
          'children',
        ])
        const parentInfo = await this.player.Native.Node.getProperty(res.parent, ['code', 'name'])
        let expandIndex = null
        if (currentLevelNodes.children?.length > 1000) {
          expandIndex = _.findIndex(currentLevelNodes.children, ['node', node.node])
        }
        await this.expendNode(parentInfo, doLocation)
        if (!this.defaultExpandedKeys.includes(parentInfo.node)) {
          // 展开
          this.defaultExpandedKeys.push(parentInfo.node)
        }
        if (expandIndex !== -1) {
          this.defaultExpandedKeys.push(
            `${parentInfo.node}${
              expandIndex % 1000 === 0 ? expandIndex / 1000 : _.ceil(expandIndex / 1000) - 1
            }`
          )
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
  },
}
</script>

<style lang="scss" scoped>
@import '..//../assets/css/base';
.model-tree {
  left: 10px;
  top: 40px;
  height: calc(100% - 60px);
  width: 400px;
  z-index: 99;
  padding: 10px;
  color: #fff !important;
  background-color: #2e6bb07f !important;
  border: none !important;
}
::v-deep .el-card__body {
  height: calc(100% - 42px);
}
.modelTree {
  overflow-y: auto;
  height: 100%;
}
.model-filter {
  // input 相关
  ::v-deep.el-input {
    width: calc(100% - 95px) !important;
    &__inner {
      font-size: 12px;
      border-radius: 4px;
      background-color: #0d1b3799 !important;
      color: #fff !important;
      border: none;
    }
  }
  ::v-deep.el-button {
    background-color: #00c0ff;
    border: none !important;
    width: 32px;
    height: 32px;
    padding: 0px !important;
    margin-left: 5px !important;
  }
}
</style>
